module.exports = __webpack_public_path__ + "static/media/penguin.97702934.svg";